:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._mobileWizard_14szl_7 {
  position: absolute;
  width: 100%;
  height: 100%; }
  ._mobileWizard_14szl_7 ._mobileWizardLeftHalf_14szl_11 {
    position: relative;
    transition: transform 1.7s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(-100%);
    box-sizing: border-box;
    text-align: center;
    background: #fff;
    width: 50%;
    left: 0;
    top: 0;
    height: 100%;
    min-width: 640px; }
  ._mobileWizard_14szl_7 ._mobileWizardTopBar_14szl_23 {
    transition: opacity 1.7s ease-in-out;
    opacity: 0;
    width: 100%;
    height: 48px;
    position: absolute;
    top: 0;
    z-index: 1; }
    ._mobileWizard_14szl_7 ._mobileWizardTopBar_14szl_23 ._topBarLeftWixLogo_14szl_31 {
      border-right: none;
      position: absolute;
      left: 23px;
      top: 15px; }
    ._mobileWizard_14szl_7 ._mobileWizardTopBar_14szl_23 ._mobileWizardTopBarSkip_14szl_36 {
      position: absolute;
      font-size: 16px;
      top: 28px;
      right: 36px; }
  ._mobileWizard_14szl_7._mobileWizardExpanded_14szl_41 ._mobileWizardLeftHalf_14szl_11 {
    transform: translateX(0); }
  ._mobileWizard_14szl_7._mobileWizardExpanded_14szl_41 ._mobileWizardTopBar_14szl_23 {
    opacity: 1; }
  ._mobileWizard_14szl_7 ._mobileWizardInner_14szl_45 {
    top: calc( 50% - 247.5px - 36px);
    position: relative; }
    ._mobileWizard_14szl_7 ._mobileWizardInner_14szl_45::after {
      content: '';
      border-right: 1px solid #d3edff;
      position: absolute;
      width: 0;
      height: 608px;
      top: 0;
      right: 0; }
    ._mobileWizard_14szl_7 ._mobileWizardInner_14szl_45 ._currentStepContainer_14szl_56 {
      min-height: 400px;
      max-width: 542px;
      margin: auto;
      width: 100%;
      box-sizing: border-box;
      padding: 12px 0; }
    ._mobileWizard_14szl_7 ._mobileWizardInner_14szl_45 ._mobileWizardActions_14szl_63 {
      justify-content: center; }
      ._mobileWizard_14szl_7 ._mobileWizardInner_14szl_45 ._mobileWizardActions_14szl_63 button:first-of-type {
        margin-left: 0; }

@keyframes _fade-in_14szl_1 {
  from {
    opacity: 0; }
  to {
    opacity: 1; } }

body {
  overflow-y: hidden; }
  ._sections-experience_14szl_76 body {
    overflow-x: hidden; }

#_preview_14szl_134 {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  border: 0;
  overflow: hidden; }

._editor-animation-manager-wrapper_14szl_87 {
  position: relative;
  height: 100vh;
  width: 100vw; }

._editor-layout-wrapper_14szl_92 {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  z-index: 0;
  background: initial !important; }
  ._editor-layout-wrapper_14szl_92._zoom-mode_14szl_99 {
    background: #f7f8f8; }

._editor-layout-header_14szl_102 {
  flex: 0 0 auto; }

._editor-layout-body_14szl_105 {
  position: relative;
  flex: 1 0 0;
  min-height: 0;
  overflow: hidden; }

._editor-layout-splitter-row_14szl_111 {
  display: flex;
  flex-direction: row;
  height: 100%; }
  ._editor-layout-splitter-row_14szl_111::before {
    content: '';
    height: 100%;
    width: var(--stage-scrollbar-width);
    position: absolute;
    top: 0;
    right: 0;
    background-color: #fafafa; }

._editor-layout-left-bar_14szl_124 {
  background-color: var(--bodyBackgroundColor);
  position: relative;
  flex: 0 0 auto;
  transition: 0.6s cubic-bezier(0.645, 0.045, 0.355, 1) width; }
  ._sections-experience_14szl_76 ._editor-layout-left-bar_14szl_124 {
    width: var(--left-bar-width); }
  ._tools-hidden_14szl_131 ._editor-layout-left-bar_14szl_124 {
    width: 0; }
  ._editor-layout-left-bar_14szl_124._expanded_14szl_133,
  ._previewMode_14szl_134 ._editor-layout-left-bar_14szl_124 {
    width: auto; }
  ._editor-layout-left-bar_14szl_124._left-panel-hidden-elements-redesign-experiment_14szl_136 button._hidden-items-panel_14szl_136 span {
    background-color: #116dff; }

._editor-content-wrapper_14szl_139 {
  position: relative;
  top: 0;
  height: 100%;
  transition: 0.6s cubic-bezier(0.645, 0.045, 0.355, 1) top, 0.6s cubic-bezier(0.645, 0.045, 0.355, 1) height; }
  ._editor-content-wrapper_14szl_139 ._secondary-left-area_14szl_144 {
    z-index: 10;
    overflow: hidden;
    border-right: 1px solid #b6c1cd; }
  ._editor-content-wrapper_14szl_139._tools-hidden_14szl_131 {
    transition: 0.4s cubic-bezier(0.645, 0.045, 0.355, 1) top, 0.4s cubic-bezier(0.645, 0.045, 0.355, 1) height; }
  ._editor-content-wrapper_14szl_139 ._splitter_14szl_150 {
    height: 100%;
    width: 100%; }
  ._editor-content-wrapper_14szl_139 ._wix-code-left-pane_14szl_153 {
    -webkit-user-select: none;
    user-select: none;
    z-index: 1072;
    position: relative; }
    ._classic-facelift-skin_14szl_160 ._editor-content-wrapper_14szl_139 ._wix-code-left-pane_14szl_153 {
      z-index: 1444; }
  ._editor-content-wrapper_14szl_139 ._wix-code-ide-pane_14szl_162 {
    -webkit-user-select: none;
    user-select: none;
    box-shadow: 10px 0 16px 0 rgba(0, 0, 0, 0.14);
    z-index: 1071; }
    ._editor-content-wrapper_14szl_139 ._wix-code-ide-pane_14szl_162._above-editor_14szl_169 {
      z-index: 1440; }
  ._editor-content-wrapper_14szl_139 ._right-pane_14szl_171 {
    z-index: 1085; }
    ._editor-content-wrapper_14szl_139 ._right-pane_14szl_171._right-pane-above-modals_14szl_173 {
      z-index: 6002; }
    ._classic-facelift-skin_14szl_160 ._editor-content-wrapper_14szl_139 ._right-pane_14szl_171 {
      border-top: 1px solid #dfe5eb;
      box-sizing: border-box; }
  ._editor-content-wrapper_14szl_139 ._ide-splitter_14szl_178 ._splitter-divider_14szl_178 {
    z-index: 1070; }
  ._editor-content-wrapper_14szl_139 ._file-pane-splitter_14szl_180 ._splitter-divider-handle_14szl_180 {
    display: none; }
  ._editor-content-wrapper_14szl_139 ._file-pane-splitter_14szl_180._file-pane-splitter-pane-0-closed_14szl_182 > ._splitter-divider_14szl_178 {
    pointer-events: none; }
  ._editor-content-wrapper_14szl_139 ._file-pane-splitter_14szl_180._file-pane-splitter-pane-0-hover_14szl_184 ._splitter-divider-handle_14szl_180:not(._closed_14szl_184), ._editor-content-wrapper_14szl_139 ._file-pane-splitter_14szl_180._file-pane-splitter-divider-hover_14szl_184 ._splitter-divider-handle_14szl_180:not(._closed_14szl_184) {
    display: block; }

._classic-facelift-skin_14szl_160 ._corvid-site-structure_14szl_187 {
  border-top: 1px solid #dfe5eb;
  box-sizing: border-box; }

._classic-facelift-skin_14szl_160 ._wix-code-ide-pane_14szl_162 {
  border-top: 1px solid #dfe5eb;
  box-sizing: border-box; }

._classic-facelift-skin_14szl_160 ._top-bar-wrapper_14szl_195 > ._next-main-top-bar_14szl_195 {
  box-shadow: none; }

._fixedEditorLayoutEditingArea_14szl_198 {
  position: relative;
  flex: 1 0 0;
  height: 100%;
  width: calc(100vw - var(--stage-left));
  overflow: auto; }
  ._fixedEditorLayoutEditingArea_14szl_198:before {
    z-index: 1450;
    content: '';
    position: absolute;
    left: 0;
    right: calc(var(--stage-right-margin) * -1);
    top: -30px;
    height: 30px;
    -webkit-clip-path: inset(30px 0 -20px 0);
            clip-path: inset(30px 0 -20px 0);
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 10px 0 rgba(0, 0, 0, 0.08), 0 1px 20px 0 rgba(0, 0, 0, 0.08);
    pointer-events: none;
    width: 100%; }

._fixedEditingArea_14szl_217 {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  overflow: visible;
  box-sizing: border-box;
  padding: 0 42px;
  --g-mobile-top: 18px;
  --g-mobile-bottom: 18px;
  --g-mobile-preview-max-height: 568px; }
  ._fixedEditingArea_14szl_217._fullWidth_14szl_229 {
    padding: 0; }
  ._fixedEditingArea_14szl_217._mobileWizardEditingArea_14szl_231 {
    overflow: hidden; }
  ._fixedEditingArea_14szl_217._newMobileEditorLayoutWithStageBanner_14szl_233 {
    --g-mobile-top: calc(
      18px + var(--stage-top)
    ); }

._previewFrameCover_14szl_238 {
  position: absolute;
  top: var(--stage-top);
  height: calc(100% - var(--stage-top) - var(--stage-bottom));
  width: 100%; }
  ._previewFrameCover_14szl_238._previewFrameCoverStageZoomMode_14szl_243 {
    top: var(--stage-top);
    height: calc(100% - var(--stage-top) - var(--stage-bottom)); }
  ._previewFrameCover_14szl_238._previewFrameCoverMobileEditor_14szl_246 {
    top: var(--g-mobile-top);
    height: calc(100% - var(--g-mobile-top) - var(--g-mobile-bottom)); }
    ._previewFrameCover_14szl_238._previewFrameCoverMobileEditor_14szl_246._previewFrameCoverPreviewMode_14szl_249 {
      max-height: var(--g-mobile-preview-max-height);
      top: 50%;
      transform: translateY(-50%); }
    ._previewFrameCover_14szl_238._previewFrameCoverMobileEditor_14szl_246._previewFrameCoverMobileWizard_14szl_253 {
      animation: _mobile-frame-wizard-animation_14szl_1 3s;
      animation-iteration-count: 1;
      animation-timing-function: ease-in-out;
      animation-fill-mode: forwards; }
    ._previewFrameCover_14szl_238._previewFrameCoverMobileEditor_14szl_246._previewFrameCoverMobileWizardOut_14szl_258 {
      animation: _mobile-frame-wizard-out-animation_14szl_1 2s;
      animation-iteration-count: 1;
      animation-timing-function: ease-in-out;
      animation-fill-mode: forwards; }
  ._previewFrameCover_14szl_238._desktopZoomModeOldTopBar_14szl_263 {
    top: 37px;
    height: calc(100% - 37px); }

._fixedPreviewFrameCover_14szl_267 {
  height: 100%;
  margin: 0 auto;
  position: relative; }

@keyframes _mobile-frame-wizard-animation_14szl_1 {
  0% {
    top: var(--g-mobile-top);
    margin-top: 0;
    max-height: 100%;
    left: 0;
    width: 100%;
    opacity: 1; }
  33% {
    top: var(--g-mobile-top);
    margin-top: 0;
    max-height: 100%;
    left: 0;
    width: 100%;
    opacity: 0; }
  66% {
    top: 50%;
    margin-top: calc(var(--g-mobile-preview-max-height) / -2);
    max-height: var(--g-mobile-preview-max-height);
    left: 50%;
    width: 50%;
    opacity: 0; }
  100% {
    top: 50%;
    margin-top: calc(var(--g-mobile-preview-max-height) / -2);
    max-height: var(--g-mobile-preview-max-height);
    left: 50%;
    width: 50%;
    opacity: 1; } }

@media (max-width: 1280px) {
  @keyframes _mobile-frame-wizard-animation_14szl_1 {
    0% {
      top: var(--g-mobile-top);
      margin-top: 0;
      max-height: 100%;
      left: 0;
      width: 100%;
      opacity: 1; }
    33% {
      top: var(--g-mobile-top);
      margin-top: 0;
      max-height: 100%;
      left: 0;
      width: 100%;
      opacity: 0; }
    66% {
      top: 50%;
      margin-top: calc(var(--g-mobile-preview-max-height) / -2);
      max-height: var(--g-mobile-preview-max-height);
      width: calc(100% - 640px);
      left: 640px;
      opacity: 0; }
    100% {
      top: 50%;
      margin-top: calc(var(--g-mobile-preview-max-height) / -2);
      max-height: var(--g-mobile-preview-max-height);
      width: calc(100% - 640px);
      left: 640px;
      opacity: 1; } } }

@keyframes _mobile-frame-wizard-out-animation_14szl_1 {
  0% {
    top: 50%;
    margin-top: calc(var(--g-mobile-preview-max-height) / -2);
    max-height: var(--g-mobile-preview-max-height);
    left: 50%;
    width: 50%;
    opacity: 1; }
  33% {
    top: 50%;
    margin-top: calc(var(--g-mobile-preview-max-height) / -2);
    max-height: var(--g-mobile-preview-max-height);
    left: 50%;
    width: 50%;
    opacity: 0; }
  66% {
    top: var(--g-mobile-top);
    margin-top: 0;
    max-height: 100%;
    left: 0;
    width: 100%;
    opacity: 0; }
  100% {
    top: var(--g-mobile-top);
    margin-top: 0;
    max-height: 100%;
    left: 0;
    width: 100%;
    opacity: 1; } }

@media (max-width: 1280px) {
  @keyframes _mobile-frame-wizard-out-animation_14szl_1 {
    0% {
      top: 50%;
      margin-top: calc(var(--g-mobile-preview-max-height) / -2);
      max-height: var(--g-mobile-preview-max-height);
      width: calc(100% - 640px);
      left: 640px;
      opacity: 1; }
    33% {
      top: 50%;
      margin-top: calc(var(--g-mobile-preview-max-height) / -2);
      max-height: var(--g-mobile-preview-max-height);
      width: calc(100% - 640px);
      left: 640px;
      opacity: 0; }
    66% {
      top: var(--g-mobile-top);
      margin-top: 0;
      max-height: 100%;
      left: 0;
      width: 100%;
      opacity: 0; }
    100% {
      top: var(--g-mobile-top);
      margin-top: 0;
      max-height: 100%;
      left: 0;
      width: 100%;
      opacity: 1; } } }

._previewWidthInfo_14szl_394 {
  left: 0;
  text-align: center;
  padding-top: 12px;
  padding-bottom: 12px;
  position: -webkit-sticky;
  position: sticky;
  height: 18px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 5px; }
